import { Button, TextInput, Toggle } from "@/ui";
import React from "react";
import AuthPage from "@/app/(auth)/components/AuthPage";
import { getTenantInfo } from "@/lib/theme/tenant";
import SelectInput, { StyledSelect } from "@/ui/forms/SelectInput";
import { allCountries, PrefixEntry } from "@/app/(auth)/components/prefixes";
import { Field, Form, Formik } from "formik";
import FormikInput from "@/ui/forms/FormikInput";

const initialValues = { prefix: "44", phoneNumber: "" };

export default function EnrollPhoneForm({ onSubmit }) {
    const onSubmitForm = (values, helpers) => {
        const phoneNumber = values.phoneNumber.startsWith("0")
            ? values.phoneNumber.substring(1)
            : values.phoneNumber;
        onSubmit(`+${values.prefix}${phoneNumber}`, helpers);
    };

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmitForm}>
            {(form) => (
                <AuthPage strapline="Lets make sure it's secure">
                    <h2 className="text-xl font-semibold font-poppins">
                        Enter your phone number
                    </h2>
                    <p className="text-base font-lato mt-1">
                        We use your phone number to send authentication codes as
                        verification.
                    </p>

                    <Form>
                        <div className="space-x-4 my-8 flex flex-row items-stretch">
                            <Field name="prefix">
                                {({ field, form }) => (
                                    <StyledSelect<PrefixEntry>
                                        value={field.value}
                                        className="w-[6rem] self-stretch -mt-0.5"
                                        options={allCountries}
                                        renderLabel={(item) => (
                                            <span className="p-2">
                                                {!item ? "+0" : item.preview}
                                            </span>
                                        )}
                                        renderOption={(item) => (
                                            <div className="inline-flex flex-row space-between w-full">
                                                <span className="flex-1">
                                                    {item?.country}
                                                </span>
                                                <span>{item?.preview}</span>
                                            </div>
                                        )}
                                        onSelect={(value) =>
                                            form.setFieldValue("prefix", value)
                                        }
                                        label="Country Code"
                                    />
                                )}
                            </Field>
                            <FormikInput
                                className="-mt-4"
                                id="phone"
                                name="phoneNumber"
                                type="tel"
                                label="Phone Number"
                            />
                        </div>

                        <Button
                            fill
                            type="button"
                            onClick={form.submitForm}
                            disabled={form.isSubmitting}>
                            Use this phone number
                        </Button>
                    </Form>
                </AuthPage>
            )}
        </Formik>
    );
}
